<div class="SLV2-story-crdbox" (click)="openStory()">
    <div class="story-icon-box">
        <span class="story-lst-cunt"></span>
        <img src="selflearnv2-ui/assets/img/self-learn-v2/stories-book-icon.svg" />
    </div>
    <div class="story-cntarea">
        <h4 class="story-title">{{story.title}}</h4>
    </div>
</div>
